import { NavLink } from 'react-router-dom'
import { useTranslation } from 'react-i18next'

import { NAVIGATION_LABELS } from '../../../helpers/constants'
import NavigationLabel from '../../NavigationLabel/NavigationLabel'

const CustomerPortalLink = () => {
  const { t } = useTranslation(['navbar'])

  return (
    <div className="hover-menu-item">
      <NavLink
        className={({ isActive }) =>
          isActive ? 'navmgr-item__link--active' : 'hover-menu-item__link'
        }
        to="/dashboard/customer-portal"
      >
        <span>
          {t('navbar:upsellingLinks.customerPortal')}
          <NavigationLabel type={NAVIGATION_LABELS.BETA} />
        </span>
      </NavLink>
    </div>
  )
}

export default CustomerPortalLink
